/**
 * @name Lottie
 */

/**---------------------------------- @name common */
export const animation_man = require('./animation/man.json')
export const loading = require('./animation/loading.json')
export const loading_page = require('./animation/loading_page.json')
